export default __webpack_public_path__ + "static/media/toDoList.c6f1acdc.png";